import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappOtp = () => (
  <>
    <Helmet>
      <title>WhatsApp OTP API for Authentication | HAWKTRION</title>
      <meta name="description" content="Integrate WhatsApp OTP delivery into authentication workflows. Connect one-time passwords and verification messages to your application with HAWKTRION." />
      <meta name="keywords" content="WhatsApp OTP API, WhatsApp authentication messages, WhatsApp verification code" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-otp/" />
      <meta property="og:title" content="WhatsApp OTP API for Authentication | HAWKTRION" />
      <meta property="og:description" content="Integrate WhatsApp OTP delivery into authentication workflows. Connect one-time passwords and verification messages to your application with HAWKTRION." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-otp/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp OTP API for Authentication | HAWKTRION" />
      <meta name="twitter:description" content="Integrate WhatsApp OTP delivery into authentication workflows. Connect one-time passwords and verification messages to your application with HAWKTRION." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp OTP for Customer Authentication" hideCta>
      <RemainingLandingContent pageKey="otp" />
    </SeoLandingPage>
  </>
);

export default WhatsappOtp;